import styled from '@emotion/styled';
import type { ActionElementProps } from 'components/inputs/types';

import { cols } from './config-table';
import type { TableFilter } from 'table/types';
import { BaseColumns } from 'types/table';
import { getComboBox } from 'utils/table';
import { Text } from 'components/text/Text';

const FilterOptionStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  white-space: normal;
`;

/** Process-type filter dropdown row — facility name above, certificate name below. */
export const ProductCertificateFilterOptionElement = ({
  label,
  facilityName,
}: ActionElementProps & { facilityName?: string }) => (
  <FilterOptionStack>
    {facilityName ? (
      <Text variant="bodyXs" color="placeholder" noWrap title={facilityName}>
        {facilityName}
      </Text>
    ) : null}
    <Text variant="bodyMd" color="secondary" noWrap title={label}>
      {label}
    </Text>
  </FilterOptionStack>
);

export const tableFilters = (vars: string[], otherCols?: BaseColumns): TableFilter[] => [
  ...Object.values(cols)
    .filter(c => Boolean(c.type))
    .map(c => {
      if (c.type === 'dd') {
        return {
          ...c,
          component: getComboBox(
            c.id,
            c.label,
            c.api,
            c.options,
            c.optionsChipRender,
            c.optionsChipProps,
            c.isInvalidOption,
            vars
          ),
          api: c.api ? { ...c.api, vars } : undefined,
          options: c.options,
        };
      }
      return c;
    }),
  ...Object.values(otherCols ?? {})
    .filter(c => Boolean(c.type))
    .map(c => {
      if (c.type === 'dd') {
        return {
          ...c,
          component: getComboBox(
            c.id,
            c.label,
            c.api,
            c.options,
            c.optionsChipRender,
            c.optionsChipProps,
            c.isInvalidOption,
            vars
          ),
          api: c.api ? { ...c.api, vars } : undefined,
          options: c.options,
        };
      }
      return c;
    }),
];
